import { SvgIcon, SvgIconProps } from '@mui/material';
import styles from './ccf-heart-icon.module.scss';

/* eslint-disable-next-line */
export interface CcfHeartIconProps extends SvgIconProps {}

/**
 * Component used to display Heart icon
 * @param props - CcfHeartIconProps
 * @returns
 * @example
 */
export function CcfHeartIcon(props: CcfHeartIconProps) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 14 14" fill="none" {...props}>
      <path
        d="M10.08 2.02627C10.15 2.02627 10.15 2.02627 10.22 2.02627C11.62 2.09258 12.6 2.35785 12.6 5.40837C12.6 6.93364 9.45 10.1168 7 11.6421C4.83 10.4484 1.4 7.33153 1.4 5.47469C1.4 2.49048 3.08 2.09258 3.78 2.02627C3.85 2.02627 3.85 2.02627 3.92 2.02627C4.9 1.95995 5.6 2.95469 5.67 3.08732L7 4.61258L8.33 3.08732C8.33 3.08732 9.1 1.95995 10.08 2.02627ZM10.08 0.699951C7.63 0.699951 7 2.68943 7 2.68943C7 2.68943 6.37 0.699951 3.92 0.699951C3.85 0.699951 3.78 0.699951 3.71 0.699951C2.03 0.766267 0 1.95995 0 5.47469C0 9.05574 7 13.3 7 13.3C7 13.3 14 8.65785 14 5.47469C14 1.95995 12.74 0.832583 10.29 0.699951C10.22 0.699951 10.15 0.699951 10.08 0.699951Z"
        fill="#3BA760"
      />
    </SvgIcon>
  );
}

export default CcfHeartIcon;
